export const appColor = '#00b4d5';

export const px = (value: string | number) =>
  Number.isFinite(value) ? `${value}px` : value || '0px';
